// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5L-SG","main-image":"Header_main-image__-pm8t"};